
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Info } from "lucide-react";

interface GenericSubscriptionAlertProps {
  status: string;
}

export const GenericSubscriptionAlert = ({ status }: GenericSubscriptionAlertProps) => {
  return (
    <Alert variant="default" className="mb-8 max-w-3xl mx-auto bg-blue-50 border-blue-200">
      <Info className="h-4 w-4 text-blue-500" />
      <AlertTitle>Subscription Status</AlertTitle>
      <AlertDescription>
        <p>Subscription status: {status}</p>
      </AlertDescription>
    </Alert>
  );
};
